import { classNameGenerator, clsx } from "@/utils"
import styles from "./StepAccordion.module.scss"
import Typography from "@/foundation/Typography/V2"
import { SVGSprite } from "@/components/Atoms"
import { useState } from "react"

const StepAccordion = ({ steps }) => {
    const cls = classNameGenerator(styles)
    const [currentIndex, setCurrentIndex] = useState(0)

    const toggleAccordion = (index) => {
        const udpateIdx = index === currentIndex ? -1 : index
        setCurrentIndex(udpateIdx)
    };

    return (
        <div className={cls("stepAccContainer")}>
            <div className={cls("stepAccWrapper")}>
                {steps?.map((item, index) => {
                    const isOpen = currentIndex == index
                    return (
                        <div className={cls("accordionRow")}>
                            <div className={cls("counterWrapper")}>
                                <span className={cls("stepCount")}>
                                    {index + 1}
                                </span>
                            </div>
                            <div
                                className={clsx(cls("accordion"), isOpen ? cls("accordion-open") : "")}
                                onClick={() => toggleAccordion(index)}
                            >
                                <div className={cls("header")}>
                                    <div className={cls("contentWrapper")}>
                                        {
                                            item?.subTitle && <Typography variant="heading4" className={cls("subTitle")}>
                                                {item?.subTitle}
                                            </Typography>
                                        }
                                        <Typography variant="heading4" className={cls("title")}>
                                            {item?.title}
                                        </Typography>
                                    </div>
                                    <div className={cls("accordion-icon")}>
                                        <SVGSprite icon={isOpen ? "icon-accordion-opened1" : "icon-accordion-closed"} />
                                    </div>
                                </div>
                                <div className={clsx(cls("content"))}>
                                    {
                                        item?.content.map((item) => {
                                            return (
                                                <div className={cls("contentBox")}>
                                                    <div className={cls("contentIcon")}>
                                                        <SVGSprite
                                                            icon="icon-list-check"
                                                            className={cls("icon")}
                                                        />
                                                    </div>
                                                    <Typography variant="paragraph1" className={cls("description")}>
                                                        {item}
                                                    </Typography>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default StepAccordion